(function () {
  'use strict';

  var DAY_NAMES = ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'];

  function parseRange(str) {
    // "10:00-16:00" -> {oh,om,ch,cm}
    if (!str) return null;
    var parts = str.split('-');
    if (parts.length !== 2) return null;
    var open = parts[0].split(':').map(Number);
    var close = parts[1].split(':').map(Number);
    if (open.length < 2 || close.length < 2) return null;
    return { oh: open[0], om: open[1], ch: close[0], cm: close[1] };
  }

  function fmt12(h, m) {
    var period = h >= 12 ? 'PM' : 'AM';
    var hh = h % 12;
    if (hh === 0) hh = 12;
    var mm = m < 10 ? '0' + m : String(m);
    return hh + ':' + mm + ' ' + period;
  }

  function getSchedule(monThuStr, friStr, dayIndex) {
    // dayIndex: 0=Sun..6=Sat
    if (dayIndex >= 1 && dayIndex <= 4) return parseRange(monThuStr);
    if (dayIndex === 5) return parseRange(friStr);
    return null;
  }

  function computeStatus(monThuStr, friStr) {
    var now = new Date();
    var day = now.getDay();
    var minutesNow = now.getHours() * 60 + now.getMinutes();
    var today = getSchedule(monThuStr, friStr, day);

    if (today) {
      var openMin = today.oh * 60 + today.om;
      var closeMin = today.ch * 60 + today.cm;
      if (minutesNow >= openMin && minutesNow < closeMin) {
        return { online: true, text: 'Online now' };
      }
      if (minutesNow < openMin) {
        return { online: false, text: 'Back online today at ' + fmt12(today.oh, today.om) };
      }
    }

    // find next open day (up to 7 days ahead)
    for (var i = 1; i <= 7; i++) {
      var d = (day + i) % 7;
      var sched = getSchedule(monThuStr, friStr, d);
      if (sched) {
        var label;
        if (i === 1) {
          label = "We'll be back tomorrow at " + fmt12(sched.oh, sched.om);
        } else {
          label = "We'll be back " + DAY_NAMES[d] + ' at ' + fmt12(sched.oh, sched.om);
        }
        return { online: false, text: label };
      }
    }
    return { online: false, text: "We'll be back soon" };
  }

  // ---------------- lightweight fuzzy-ish search ----------------
  function normalize(str) {
    return (str || '').toLowerCase().replace(/[^\w\s]/g, ' ').replace(/\s+/g, ' ').trim();
  }

  function buildIndex(widget) {
    var items = widget.querySelectorAll('[data-bsw-faq-item]');
    var index = [];
    items.forEach(function (el) {
      var question = el.getAttribute('data-question') || '';
      var answerEl = el.querySelector('.bsw__faq-answer-source');
      var answerText = answerEl ? answerEl.textContent : '';
      index.push({
        el: el,
        category: el.getAttribute('data-category'),
        question: question,
        qNorm: normalize(question),
        aNorm: normalize(answerText)
      });
    });
    return index;
  }

  function search(index, query) {
    var qNorm = normalize(query);
    if (!qNorm) return [];
    var tokens = qNorm.split(' ').filter(Boolean);
    var results = [];
    index.forEach(function (item) {
      var score = 0;
      tokens.forEach(function (t) {
        if (item.qNorm.indexOf(t) !== -1) score += 3;
        else if (item.aNorm.indexOf(t) !== -1) score += 1;
        else {
          // loose startsWith match against individual words (typo tolerance-ish)
          var words = item.qNorm.split(' ');
          for (var i = 0; i < words.length; i++) {
            if (words[i].indexOf(t) === 0 || t.indexOf(words[i]) === 0) { score += 1; break; }
          }
        }
      });
      if (score > 0) results.push({ item: item, score: score });
    });
    results.sort(function (a, b) { return b.score - a.score; });
    return results.slice(0, 8).map(function (r) { return r.item; });
  }

  var CATEGORY_LABELS = {
    product: 'Product & Ingredients', ordering: 'Ordering & Checkout', payment: 'Payment & Promotions',
    shipping: 'Shipping & Delivery', returns: 'Returns & Issues', rewards: 'Rewards & Newsletter',
    service: 'Customer Service', club: 'Brekery Club', corporate: 'Corporate Gifting', catering: 'Catering'
  };

  // ---------------- widget wiring ----------------
  document.querySelectorAll('[data-bsw]').forEach(function (widget) {
    var toggle = widget.querySelector('[data-bsw-toggle]');
    var overlay = widget.querySelector('[data-bsw-overlay]');
    var panel = widget.querySelector('[data-bsw-panel]');
    var closeBtns = widget.querySelectorAll('[data-bsw-close]');
    var statusEls = widget.querySelectorAll('[data-bsw-status]');
    var hoursAttr = widget.getAttribute('data-hours') || '10:00-16:00|10:00-14:00';
    var hoursParts = hoursAttr.split('|');
    var monThuStr = hoursParts[0], friStr = hoursParts[1];

    var screens = {};
    widget.querySelectorAll('[data-bsw-screen]').forEach(function (s) {
      screens[s.getAttribute('data-bsw-screen')] = s;
    });

    function updateStatus() {
      var status = computeStatus(monThuStr, friStr);
      statusEls.forEach(function (el) {
        el.textContent = status.text;
        el.classList.toggle('is-online', status.online);
      });
    }
    updateStatus();
    setInterval(updateStatus, 60000);

    function showScreen(name) {
      Object.keys(screens).forEach(function (key) {
        screens[key].hidden = key !== name;
      });
    }

    function open() {
      overlay.hidden = false;
      panel.hidden = false;
      document.body.style.overflow = 'hidden';
    }
    function close() {
      overlay.hidden = true;
      panel.hidden = true;
      document.body.style.overflow = '';
      resetToFreshHome();
    }
    function resetToFreshHome() {
      showScreen('home');
      if (searchInput) searchInput.value = '';
      if (resultsWrap) resultsWrap.hidden = true;
      if (defaultWrap) defaultWrap.hidden = false;
    }
    toggle.addEventListener('click', function () {
      if (panel.hidden) { open(); showScreen('home'); } else { close(); }
    });
    overlay.addEventListener('click', close);
    closeBtns.forEach(function (b) { b.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !panel.hidden) close();
    });
    widget.querySelectorAll('[data-bsw-back]').forEach(function (b) {
      b.addEventListener('click', function () { showScreen(b.getAttribute('data-bsw-back')); });
    });

    // ---- FAQ index + featured ----
    var faqIndex = buildIndex(widget);

    var featuredWrap = widget.querySelector('[data-bsw-featured]');
    if (featuredWrap) {
      var flagged = [];
      widget.querySelectorAll('[data-bsw-faq-item]').forEach(function (el) {
        if (el.hasAttribute('data-featured')) flagged.push(el);
      });
      var pool = flagged.length ? flagged : Array.prototype.slice.call(widget.querySelectorAll('[data-bsw-faq-item]')).slice(0, 5);
      pool.forEach(function (el) {
        var q = el.getAttribute('data-question');
        var row = document.createElement('button');
        row.type = 'button';
        row.className = 'bsw__cat-row';
        row.innerHTML = '<span>' + q + '</span><svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9 6l6 6-6 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
        row.addEventListener('click', function () { askFaqInChat(el); });
        featuredWrap.appendChild(row);
      });
    }

    function openCategory(cat) {
      showScreen('category');
      widget.querySelectorAll('[data-bsw-cat-panel]').forEach(function (p) {
        p.hidden = p.getAttribute('data-bsw-cat-panel') !== cat;
      });
      var titleEl = widget.querySelector('[data-bsw-cat-title]');
      if (titleEl) titleEl.textContent = CATEGORY_LABELS[cat] || cat;
    }

    widget.querySelectorAll('[data-bsw-cat-open]').forEach(function (btn) {
      btn.addEventListener('click', function () { openCategory(btn.getAttribute('data-bsw-cat-open')); });
    });

    // ---- FAQ: tapping a question opens the answer as a chat conversation ----
    widget.querySelectorAll('[data-bsw-faq-open]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        askFaqInChat(btn.closest('[data-bsw-faq-item]'));
      });
    });

    function askFaqInChat(itemEl) {
      var question = itemEl.getAttribute('data-question');
      var answerSource = itemEl.querySelector('.bsw__faq-answer-source');
      var answerHTML = answerSource ? answerSource.innerHTML : '';
      chatLog.innerHTML = '';
      disableComposer();
      showScreen('chat');
      userSay(question);
      botSayTyping(answerHTML, function () {
        botSayTyping('Did that sort things out for you?', function () {
          showChoices(['Yes, thank you', 'No, I need more help'], function (choice) {
            userSay(choice);
            if (choice === 'Yes, thank you') {
              botSayTyping('Great, glad that helped! \uD83C\uDF6A We\u2019re here anytime you need us.', showBackToHome);
            } else {
              askAdditionalDetails(question);
            }
          });
        }, 500);
      });
    }

    // ---- search ----
    var searchInput = widget.querySelector('[data-bsw-search]');
    var resultsWrap = widget.querySelector('[data-bsw-search-results]');
    var defaultWrap = widget.querySelector('[data-bsw-home-default]');
    var searchTimer;
    if (searchInput) {
      searchInput.addEventListener('input', function () {
        clearTimeout(searchTimer);
        searchTimer = setTimeout(function () {
          var q = searchInput.value.trim();
          if (!q) {
            resultsWrap.hidden = true;
            defaultWrap.hidden = false;
            return;
          }
          defaultWrap.hidden = true;
          resultsWrap.hidden = false;
          var results = search(faqIndex, q);
          resultsWrap.innerHTML = '';
          if (!results.length) {
            var empty = document.createElement('div');
            empty.className = 'bsw__search-empty';
            empty.textContent = "No results. Try leaving us a message instead.";
            resultsWrap.appendChild(empty);
            return;
          }
          results.forEach(function (item) {
            var btn = document.createElement('button');
            btn.type = 'button';
            btn.className = 'bsw__search-result';
            btn.innerHTML = '<span class="bsw__search-result-cat">' + (CATEGORY_LABELS[item.category] || '') + '</span><br>' + item.question;
            btn.addEventListener('click', function () {
              searchInput.value = '';
              resultsWrap.hidden = true;
              defaultWrap.hidden = false;
              askFaqInChat(item.el);
            });
            resultsWrap.appendChild(btn);
          });
        }, 180);
      });
    }

    // ---- bot chat flow ----
    var chatLog = widget.querySelector('[data-bsw-chat-log]');
    var composer = widget.querySelector('[data-bsw-composer]');
    var composerInput = widget.querySelector('[data-bsw-composer-input]');
    var pendingComposerCb = null;

    function scrollLog() { chatLog.scrollTop = chatLog.scrollHeight; }

    function botSay(html) {
      var wrap = document.createElement('div');
      wrap.className = 'bsw__msg bsw__msg--bot';
      wrap.innerHTML = '<p class="bsw__msg-name">Customer Support Bot</p><div class="bsw__msg-bubble">' + html + '</div><p class="bsw__msg-tag">Automated</p>';
      chatLog.appendChild(wrap);
      scrollLog();
    }

    function showTyping() {
      var wrap = document.createElement('div');
      wrap.className = 'bsw__msg bsw__msg--bot';
      wrap.innerHTML = '<p class="bsw__msg-name">Customer Support Bot</p><div class="bsw__msg-bubble bsw__typing"><span></span><span></span><span></span></div>';
      chatLog.appendChild(wrap);
      scrollLog();
      return wrap;
    }

    // Shows a brief "typing" indicator, then swaps it for the real message.
    // If cb is given, it fires right after the message appears (for chaining).
    function botSayTyping(html, cb, delay) {
      var typingEl = showTyping();
      setTimeout(function () {
        typingEl.remove();
        botSay(html);
        if (cb) cb();
      }, delay || (500 + Math.random() * 400));
    }

    function userSay(text) {
      var wrap = document.createElement('div');
      wrap.className = 'bsw__msg bsw__msg--user';
      var bubble = document.createElement('div');
      bubble.className = 'bsw__msg-bubble';
      bubble.textContent = text;
      wrap.appendChild(bubble);
      chatLog.appendChild(wrap);
      scrollLog();
    }

    function showChoices(labels, cb) {
      var wrap = document.createElement('div');
      wrap.className = 'bsw__choices';
      labels.forEach(function (label) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'bsw__choice-btn';
        btn.textContent = label;
        btn.addEventListener('click', function () {
          wrap.remove();
          cb(label);
        });
        wrap.appendChild(btn);
      });
      chatLog.appendChild(wrap);
      scrollLog();
    }

    function showInlineField(labelText, placeholder, maxLen, cb) {
      var wrap = document.createElement('div');
      wrap.className = 'bsw__inline-field';
      wrap.innerHTML =
        '<div class="bsw__inline-field-box">' +
        '<p class="bsw__inline-field-label">' + labelText + '</p>' +
        '<div class="bsw__inline-field-row">' +
        '<input type="text" maxlength="' + maxLen + '" placeholder="' + placeholder + '">' +
        '<button type="button" class="bsw__inline-field-send" aria-label="Send">&#8250;</button>' +
        '</div>' +
        '<p class="bsw__inline-field-count">0/' + maxLen + ' characters</p>' +
        '</div>';
      var input = wrap.querySelector('input');
      var count = wrap.querySelector('.bsw__inline-field-count');
      var send = wrap.querySelector('.bsw__inline-field-send');
      input.addEventListener('input', function () {
        count.textContent = input.value.length + '/' + maxLen + ' characters';
      });
      function submit() {
        var val = input.value.trim();
        if (!val) return;
        wrap.remove();
        cb(val);
      }
      send.addEventListener('click', submit);
      input.addEventListener('keydown', function (e) { if (e.key === 'Enter') submit(); });
      chatLog.appendChild(wrap);
      scrollLog();
      input.focus();
    }

    function enableComposer(cb) {
      composer.hidden = false;
      pendingComposerCb = cb;
      composerInput.focus();
    }
    function disableComposer() {
      composer.hidden = true;
      pendingComposerCb = null;
      composerInput.value = '';
      composerInput.style.height = '';
    }

    if (composerInput) {
      composerInput.addEventListener('input', function () {
        composerInput.style.height = 'auto';
        composerInput.style.height = Math.min(composerInput.scrollHeight, 66) + 'px';
      });
      composerInput.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' && !e.shiftKey) {
          e.preventDefault();
          composer.requestSubmit ? composer.requestSubmit() : composer.dispatchEvent(new Event('submit', { cancelable: true }));
        }
      });
    }

    if (composer) {
      composer.addEventListener('submit', function (e) {
        e.preventDefault();
        var text = composerInput.value.trim();
        if (!text) return;
        userSay(text);
        var cb = pendingComposerCb;
        disableComposer();
        if (cb) cb(text);
      });
    }

    function showEmailConsentField(cb) {
      var maxLen = 100;
      var wrap = document.createElement('div');
      wrap.className = 'bsw__inline-field';
      wrap.innerHTML =
        '<div class="bsw__inline-field-box">' +
        '<p class="bsw__inline-field-label">What\u2019s the best email to reach you?</p>' +
        '<div class="bsw__inline-field-row">' +
        '<input type="email" maxlength="' + maxLen + '" placeholder="you@example.com">' +
        '<button type="button" class="bsw__inline-field-send" aria-label="Send" disabled>&#8250;</button>' +
        '</div>' +
        '<label class="bsw__consent">' +
        '<input type="checkbox" data-bsw-consent>' +
        '<span>I agree to the <a href="/policies/privacy-policy" target="_blank" rel="noopener">Privacy Policy</a> and consent to my data being used to respond to this request.</span>' +
        '</label>' +
        '</div>';
      var input = wrap.querySelector('input[type="email"]');
      var consent = wrap.querySelector('[data-bsw-consent]');
      var send = wrap.querySelector('.bsw__inline-field-send');
      function refresh() {
        send.disabled = !(input.value.trim() && consent.checked);
      }
      input.addEventListener('input', refresh);
      consent.addEventListener('change', refresh);
      function submit() {
        var val = input.value.trim();
        if (!val || !consent.checked) return;
        wrap.remove();
        cb(val);
      }
      send.addEventListener('click', submit);
      input.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); submit(); } });
      chatLog.appendChild(wrap);
      scrollLog();
      input.focus();
    }

    function askEmailThenSubmit(subject, message) {
      showEmailConsentField(function (email) {
        submitMessage(subject, message, email);
      });
    }

    function submitMessage(subject, message, email) {
      var body = 'Subject: ' + subject + '\n\n' + (message || '(no additional details)');

      var formData = new FormData();
      formData.append('form_type', 'contact');
      formData.append('utf8', '\u2713');
      formData.append('contact[name]', 'Website support widget');
      formData.append('contact[email]', email);
      formData.append('contact[body]', body);

      fetch('/contact', { method: 'POST', body: formData })
        .then(function () {
          botSayTyping("Thanks! We've received your message and will get back to you as soon as possible.", showBackToHome);
        })
        .catch(function () {
          botSayTyping("Sorry, something went wrong sending your message. Please try again in a moment.", showBackToHome);
        });
    }

    function showBackToHome() {
      var wrap = document.createElement('div');
      wrap.style.textAlign = 'center';
      wrap.style.margin = '16px 0 8px';
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.textContent = '\u2190 Back to Home';
      btn.className = 'bsw__back-home-btn';
      btn.addEventListener('click', function () { showScreen('home'); });
      wrap.appendChild(btn);
      chatLog.appendChild(wrap);
      scrollLog();
    }

    function askAdditionalDetails(subject) {
      botSayTyping('Got it. Feel free to add any extra details \u2014 order number, dates, anything that will help us sort this out faster.', function () {
        enableComposer(function (message) {
          askEmailThenSubmit(subject, message);
        });
      });
    }

    function startMenu() {
      var status = computeStatus(monThuStr, friStr);
      botSayTyping(
        'Welcome to Brekery\u00ae support! A couple of things before we dive in: this chat runs on an automated assistant (no live person on the other end just yet), and anything you share here helps us follow up and keep improving how we help customers. Full details live in our <a href="/policies/privacy-policy" target="_blank" rel="noopener">Privacy Policy</a>.',
        function () {
          botSayTyping('Let\u2019s narrow it down \u2014 which of these fits best?', function () {
            showChoices(['Track Order', 'Report Issue', 'Cancel Order', 'Product Question', 'Other'], function (choice) {
              userSay(choice);
              if (choice === 'Other') {
                showInlineField('No worries \u2014 what would you like to tell us about?', 'Subject', 100, function (subject) {
                  userSay(subject);
                  askAdditionalDetails(subject);
                });
              } else {
                askAdditionalDetails(choice);
              }
            });
          }, 500);
        }
      );
    }

    function openChat(prefillQuestion) {
      chatLog.innerHTML = '';
      disableComposer();
      showScreen('chat');
      if (prefillQuestion) {
        userSay(prefillQuestion);
        askAdditionalDetails(prefillQuestion);
      } else {
        startMenu();
      }
    }

    widget.querySelectorAll('[data-bsw-open-chat]').forEach(function (btn) {
      btn.addEventListener('click', function () { openChat(); });
    });
  });
})();